import type { AlienRuleSection } from './types';

export const monolithSections: AlienRuleSection[] = [
  {
    "id": "ai:monolith:overview",
    "scenarioId": "monolith",
    "title": "Opis trybu",
    "summary": "Specjalny tryb solo bez automy Lacerda.",
    "bullets": [
      "1 gracz",
      "Konfigurowalny poziom trudności",
      "15 rund",
      "Cel: ukończyć co najmniej 4 z 5 celów"
    ]
  },
  {
    "id": "ai:monolith:components",
    "scenarioId": "monolith",
    "title": "Komponenty",
    "bullets": [
      "12 celów ulepszeń",
      "6 celów naukowców",
      "12 celów kontraktów",
      "4 cele odkryć",
      "8 celów technologii",
      "16 kart sabotażu",
      "tor czasu i znacznik z rozdziału 2"
    ]
  },
  {
    "id": "ai:monolith:setup",
    "scenarioId": "monolith",
    "title": "Przygotowanie",
    "steps": [
      "Nie używaj zasad solo z gry podstawowej.",
      "Magazyn przygotuj jak dla 2 graczy.",
      "Znaczniki misji ustaw na połowie wartości dla 2 graczy, zaokrąglając w górę.",
      "Tor czasu połóż stroną 15, a znacznik na 0.",
      "Kostki nieużywanego koloru stają się kostkami sabotażu.",
      "Odkryj 2 karty sabotażu. Jeżeli mają tę samą literę, połóż kostkę na lewym wolnym polu lewej karty.",
      "Podziel cele na 5 talii.",
      "Z dwóch talii dobierz po losowym celu, z trzech pozostałych wybierz po jednym.",
      "Więcej losowych wyborów zwiększa trudność."
    ]
  },
  {
    "id": "ai:monolith:goals",
    "scenarioId": "monolith",
    "title": "Pięć typów celów",
    "bullets": [
      "Ulepsz wskazanym projektem budynek należący do kompleksu co najmniej rozmiaru 3.",
      "Ukończ wskazany kontrakt.",
      "Rozwiń wskazaną technologię do maksimum.",
      "Zdobądź co najmniej 9 OP wskazanym naukowcem.",
      "Zdobądź wskazaną liczbę kafli badań i/lub odkryć."
    ]
  },
  {
    "id": "ai:monolith:victory",
    "scenarioId": "monolith",
    "title": "Zwycięstwo i porażka",
    "bullets": [
      "Wygrywasz po ukończeniu co najmniej 4 z 5 celów.",
      "Przegrywasz, gdy znacznik czasu przechodzi z 14 na 15, a nie masz 4 celów.",
      "Tor pozostałych misji nie uruchamia końca gry."
    ]
  },
  {
    "id": "ai:monolith:sabotage-phase",
    "scenarioId": "monolith",
    "title": "Faza sabotażu",
    "steps": [
      "Po fazie kolonizacji, przed fazą wahadłowca, zwiększ czas o 1.",
      "Jeżeli znacznik wszedł na pole z ikoną Obcego, rozpatrz od lewej wszystkie karty mające 2 kostki.",
      "Wykonaj efekt, odrzuć kartę i zwróć kostki.",
      "Dołóż nową kartę na prawy koniec rzędu.",
      "Jeżeli jej litera występuje już w rzędzie, dołóż kostkę na lewym wolnym polu karty z tą literą."
    ]
  },
  {
    "id": "ai:monolith:scoring",
    "scenarioId": "monolith",
    "title": "Wynik końcowy",
    "bullets": [
      "0 celów: −50 OP",
      "1 cel: −25 OP",
      "2 cele: −15 OP",
      "3 cele: 0 OP",
      "4 cele: +25 OP",
      "5 celów: +50 OP",
      "Każda ukończona misja: +10 OP",
      "150+: Star Child",
      "125+: Planet Tamer",
      "100+: Pioneer",
      "75+: Explorer",
      "50+: Passenger",
      "49 lub mniej: Lost in Space"
    ]
  }
];
